export default __webpack_public_path__ + "static/media/message.b18810b6.png";